import { render } from "./CounselorsIndex.vue?vue&type=template&id=5d966de1&scoped=true"
import script from "./CounselorsIndex.vue?vue&type=script&lang=js"
export * from "./CounselorsIndex.vue?vue&type=script&lang=js"

import "./CounselorsIndex.vue?vue&type=style&index=0&id=5d966de1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d966de1"]])

export default __exports__